/**
 * Input normalization for the Dutch board (spec §2).
 *
 * Three rules, in one place so the word lists, the validator and the evaluator
 * all agree:
 *
 *  - **Diacritics are stripped** — `ë → e`, `é → e` — via NFD decomposition and
 *    dropping the combining marks (U+0300–U+036F). This is why the committed word
 *    lists are generated with this exact function: a stored word and a typed word
 *    must fold to the same key or validation would miss.
 *  - **Everything is uppercased**, so evaluation and lookup are case-blind.
 *  - **'IJ' is two tiles, never one.** There is deliberately no special case for
 *    it: `I` and `J` are ordinary letters, so `BLIJF` is five tiles, exactly as
 *    §2 requires. The absence of code here is the feature.
 */
export function normalize(word) {
    return word
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toUpperCase();
}
/** Whether a *normalized* word is exactly `length` ASCII letters (spec §2 length rule). */
export function isWordShape(word, length) {
    return word.length === length && /^[A-Z]+$/.test(word);
}
//# sourceMappingURL=normalize.js.map